import type { Readable } from 'stream';

export const streamToBuffer = async (stream: Readable): Promise<Buffer> => {
  return new Promise<Buffer>((resolve, reject) => {
    const chunks: Buffer[] = [];
    stream.on('data', (chunk) => chunks.push(chunk));
    stream.on('end', () => {
      resolve(Buffer.concat(chunks));
    });
    stream.on('error', (error) => {
      reject(error);
    });
  });
};
